// extracted by mini-css-extract-plugin
export default {"textarea-control":"textarea_textarea-control__WhUrD","description":"textarea_description__6grC-","textarea":"textarea_textarea__cAJwM"};